import { ErrorHandler, Injectable, Injector } from '@angular/core';
import {
  MessageTypeEnum,
  UpsertTypeEnum,
} from 'src/app/ngrx-message/constants/messageTypeEnum';
import { Message } from 'src/app/ngrx-message/models/client/message';
import { MessageStoreService } from 'src/app/ngrx-message/services/message/message-store.service';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  handleError(error: any) {
    try {
      const messageStoreService = this.injector.get(MessageStoreService);

      const isCloseEvent = error instanceof CloseEvent;
      const isWebSocketClose = error?.target instanceof WebSocket;
      const isGenericEvent = error instanceof Event;

      const errorToString = Object.prototype.toString.call(error); // e.g. "[object CloseEvent]"

      const isSilencable =
        isCloseEvent ||
        isWebSocketClose ||
        isGenericEvent ||
        errorToString.includes('[object CloseEvent]') ||
        errorToString.includes('[object Event]');

      if (isSilencable) {
        console.warn(
          'Non-critical event error suppressed:',
          errorToString,
          error,
        );
        return;
      }

      const fallbackMessage = 'An unexpected error occurred';

      const message = {
        type: MessageTypeEnum.error,
        display: error?.message || fallbackMessage,
        stack: error?.stack || JSON.stringify(error),
        watermark: new Date().toUTCString(),
        read: true,
      } as Message;

      messageStoreService?.upsertMessage(message, UpsertTypeEnum.global);
    } catch (handlingError) {
      console.error('Error while handling another error:', handlingError);
    }

    super.handleError(error);
  }

  testError(): void {
    this.handleError(new Error('TestError'));
  }
}
